import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CustomPattern } from 'src/app-core/pattern/custom-pattern';
import { CommonService } from 'src/app-core/services/common.service';
import { ContactService } from 'src/app/contacts/contact.service';
import { CountryLookupEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';

@Component({
    selector: 'app-add-address',
    templateUrl: './add-address.component.html',
    styleUrls: ['./add-address.component.scss'],
})
export class AddAddressComponent implements OnInit {
    
    pattern = new CustomPattern();
    addressData: any;
    accountId: string;
    commonDataModel = new CommonDataModel();
    addressFormList: any = this.commonDataModel.addressFormListModel;
    countryLookupEnum: typeof CountryLookupEnum = CountryLookupEnum;
    countries: any = [];
    copyCountriesList: any = [];
    provinces: any = [];
    isLoading = false;
    isFormLoading = false;

    constructor(
        private commonService: CommonService,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private contactService: ContactService,
        private toastr: ToastrService,
        public dialogRef: MatDialogRef<AddAddressComponent>) {
        this.addressData = data;
    }

    ngOnInit() {
        this.loadItems();
    }

    loadItems(): void {
        this.getCountries();
        if (this.addressData.addressId) {
            this.isFormLoading = true;
            if (this.addressData.isBooking) {
                this.editAddressBooking()
            } else {
                this.editAddress();
            }
        }
    }

    editAddress() {
        this.contactService.editAddress(this.addressData.accountId, this.addressData.addressId)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                if (response.isSuccess) {
                    const formattedResponse = this.commonService.getObjectValueAsString(response.data);
                    this.addressFormList = formattedResponse;
                    var cId: number = + this.addressFormList.countryId;
                    this.addressFormList.countryId = cId;
                    this.isFormLoading = false;
                }
            });
    }

    editAddressBooking() {
        this.contactService.editAddressBooking(this.addressData.accountId, this.addressData.addressId)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                if (response.isSuccess) {
                    const formattedResponse = this.commonService.getObjectValueAsString(response.data);
                    this.addressFormList = formattedResponse;
                    var cId: number = + this.addressFormList.countryId;
                    this.addressFormList.countryId = cId;
                    this.isFormLoading = false;
                }
            });
    }

    onSubmit(): void {
        this.isLoading = true;
        this.addressFormList.accountId = this.addressData.accountId;
        if (this.addressData.isBooking) {
            this.addressFormList.IsOrderUpdate = true;
            this.addressFormList.OrderId = this.addressData.orderId;
        }
        if (this.addressFormList.addressId) {
            this.contactService.updateAddress(this.addressFormList)
                .pipe(finalize(() => (this.isLoading = false)))
                .subscribe(response => {
                    this.onClose(response.data);
                    this.isLoading = false;
                    this.toastr.success('Address updated successfully.');
                });
        } else {
            this.contactService.createAddress(this.addressFormList)
                .pipe(finalize(() => (this.isLoading = false)))
                .subscribe(response => {
                    this.onClose(response.data);
                    this.isLoading = false;
                    this.toastr.success('Address added successfully.');
                });
        }
    }

    getCountries(): void {
        this.commonService.getCountries().subscribe(response => {
            if (response.isSuccess) {
                this.countries = response.data;
                this.copyCountriesList = response.data;
                if (!this.addressData.addressId) {
                    // set default as USA
                    this.addressFormList.countryId = this.countryLookupEnum.USA;
                }
            }
        });
    }

    onCountryChange() {
        this.addressFormList.province = null;
        this.addressFormList.city = null;
        this.addressFormList.zipCode = null;
    }


    onChangeZip(searchText: string): void {
        if (searchText && searchText.length >= 3 && this.addressFormList.countryId == this.countryLookupEnum.USA) {
            this.isFormLoading = true;
            this.commonService.getPostalCodeDetails(searchText)
                .pipe(finalize(() => (this.isFormLoading = false)))
                .subscribe(response => {
                    if (response.isSuccess) {
                        this.addressFormList.countryId = response.data.countryId.toString();
                        this.addressFormList.province = response.data.provinceName;
                        this.addressFormList.city = response.data.city;
                    } else {
                        this.toastr.warning(response.errors);
                        this.clearLocationDetails();
                    }
                    this.isFormLoading = false;
                });
        } else {
            this.clearLocationDetails();
        }
    }

    clearLocationDetails() {
        this.addressFormList.province = null;
        this.addressFormList.city = '';
    }

    bindZipCode(item: any): string | undefined {
        return item ? item.zip : undefined;
    }

    onClose(addressId?: any): void {
        this.dialogRef.close(addressId);
    }

    handleFilter(value: any) {
        this.countries = this.copyCountriesList.filter((s) => s.countryName.toLowerCase().indexOf(value.toLowerCase()) !== -1)
    }
}
